const ModalTypes = {
    LEVIA_LEAR_MORE: 'LEVIA_LEAR_MORE',
    BROWSER_NOT_COMPATIBLE: 'BROWSER_NOT_COMPATIBLE',
    CONSUMER_FEEDBACK_GATHERING: 'CONSUMER_FEEDBACK_GATHERING',
    LANGUAGE_SELECT: 'LANGUAGE_SELECT',
    FIRMWARE_AVAILABLE: 'FIRMWARE_AVAILABLE',
    MAINTENANCE: 'MAINTENANCE',
    ENABLE_NOTIFICATION: 'ENABLE_NOTIFICATION',
    ENABLE_NOTIFICATION_REMINDER: 'ENABLE_NOTIFICATION_REMINDER',
    RESET_NOTIFICATION_PERMISSIONS: 'RESET_NOTIFICATION_PERMISSIONS',
    AUTO_DELIVERY_STATUS_NONE_DETAILS: 'AUTO_DELIVERY_STATUS_NONE_DETAILS',
    AUTO_DELIVERY_STATUS_INACTIVE_DETAILS: 'AUTO_DELIVERY_STATUS_INACTIVE_DETAILS',
    QUICK_ORDER: 'QUICK_ORDER',
    CONNECTION_SELECTION: 'CONNECTION_SELECTION',
    CONNECTION_CANCELLATION: 'CONNECTION_CANCELLATION',
    HOLDER_REGISTRATION: 'HOLDER_REGISTRATION',
    DEVICE_REGISTRATION_ERROR: 'DEVICE_REGISTRATION_ERROR',
    EARN_BADGE: 'EARN_BADGE',
    COMPLETE_JOURNEY_LEVEL_TASK: 'COMPLETE_JOURNEY_LEVEL_TASK',
    NEXT_JOURNEY_LEVEL_TASK: 'NEXT_JOURNEY_LEVEL_TASK',
    NEW_BADGE: 'NEW_BADGE',
    EXPIRING_BADGE: 'EXPIRING_BADGE',
    AGE_GATE_DENIED: 'AGE_GATE_DENIED',
};

export default ModalTypes;
